import { createFileRoute } from '@tanstack/react-router';
import { AppUpdate } from '@/features/system/AppUpdate';

export const Route = createFileRoute('/_app/update-app')({ component: AppUpdate });
